import { Button } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import { Id, useAppNotification } from '@feature/utils';

import { useMinStdAddAllIndicatorItems } from '../model/MinStdQuery';

export interface AddAllOptionsButtonProps {
  authorId: Id;
  indicatorCode: string;
  year: number | null;
}

export function AddAllOptionsButton({ authorId, indicatorCode, year }: AddAllOptionsButtonProps) {
  const { mutate, isPending } = useMinStdAddAllIndicatorItems(authorId, indicatorCode, year);
  const { t } = useTranslation();

  const notification = useAppNotification();
  const onSubmit = () => {
    mutate(undefined, {
      onSuccess: notification.success,
      onError: notification.error,
    });
  };

  return (
    <Button
      loading={isPending}
      size="xs"
      onClick={onSubmit}
    >
      {t('minStd.addAllPossibleItems')}
    </Button>
  );
}
